import React from 'react';
import PropTypes from 'prop-types';

const PrintableView = ({ title, columns, data, translations }) => {
  return (
    <div className="print-only">
      <style>
        {`
          @media print {
            @page {
              margin: 0.5cm 1cm 1cm 0.5cm;
              @bottom-right {
                content: counter(page) " / " counter(pages);
                font-size: 12pt;
              }
            }
            tr {
              page-break-inside: avoid;
            }
          }
        `}
      </style>
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="print-header">
          <tr>
            <th colSpan={columns.length} className="px-6 py-4 bg-white">
              <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
                <p className="text-sm text-gray-500">{new Date().toLocaleDateString()}</p>
              </div>
            </th>
          </tr>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-100"
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((item, index) => (
            <tr key={item.id || index}>
              {columns.map((column) => (
                <td
                  key={`${item.id}-${column.key}`}
                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                >
                  {column.render ? column.render(item) : item[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={columns.length} className="px-6 py-4 text-sm text-gray-500">
              {translations.pagination.totalItems}: {data.length}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

PrintableView.propTypes = {
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      render: PropTypes.func
    })
  ).isRequired,
  data: PropTypes.array.isRequired,
  translations: PropTypes.shape({
    pagination: PropTypes.shape({
      totalItems: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default PrintableView; 